'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.AU = null;
  this.AU = init;
}
export { $c_s_util_DynamicVariable as $c_s_util_DynamicVariable };
$p = $c_s_util_DynamicVariable.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
}
export { $h_s_util_DynamicVariable as $h_s_util_DynamicVariable };
$h_s_util_DynamicVariable.prototype = $p;
$p.b = (function() {
  return (("DynamicVariable(" + this.AU) + ")");
});
var $d_s_util_DynamicVariable = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_DynamicVariable, "scala.util.DynamicVariable", ({
  wd: 1
}));
export { $d_s_util_DynamicVariable as $d_s_util_DynamicVariable };
